// extracted by mini-css-extract-plugin
export var group = "input-module--group--7ff8e";
export var input = "input-module--input--bbafe";
export var label = "input-module--label--8d14a";